export const MORNING_RANGE = '09:00 a 12:00';
export const AFTERNOON_RANGE = '12:00 a 15:00';

export interface ShippingScheduleRange {
    label: string;
    time: string;
    days: string;
    weekdays: number[];
}

const macrocentroSchedule: ShippingScheduleRange[] = [
    { label: 'Mañana', time: MORNING_RANGE, days: 'Lunes, miércoles y viernes', weekdays: [1, 3, 5] },
    { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Martes, jueves y sábado', weekdays: [2, 4, 6] }
];

const suburbSchedule: ShippingScheduleRange[] = [
    { label: 'Mañana', time: MORNING_RANGE, days: 'Martes, jueves y sábado', weekdays: [2, 4, 6] },
    { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Lunes, miércoles y viernes', weekdays: [1, 3, 5] }
];

const fullWeekSchedule: ShippingScheduleRange[] = [
    { label: 'Mañana', time: MORNING_RANGE, days: 'Lunes a sábado', weekdays: [1, 2, 3, 4, 5, 6] },
    { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Lunes a sábado', weekdays: [1, 2, 3, 4, 5, 6] }
];

const normalize = (value: string) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const getShippingSchedule = (mapZoneName = '', shippingZoneId = ''): ShippingScheduleRange[] => {
    const zone = normalize(mapZoneName);

    if (zone.includes('macrocentro')) return macrocentroSchedule;
    if (zone.includes('norte')) {
        return [
            { label: 'Mañana', time: MORNING_RANGE, days: 'Lunes', weekdays: [1] },
            { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Jueves', weekdays: [4] }
        ];
    }
    if (zone.includes('oeste')) {
        return [
            { label: 'Mañana', time: MORNING_RANGE, days: 'Viernes', weekdays: [5] },
            { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Martes', weekdays: [2] }
        ];
    }
    if (zone.includes('sur')) {
        return [
            { label: 'Mañana', time: MORNING_RANGE, days: 'Miércoles', weekdays: [3] },
            { label: 'Tarde', time: AFTERNOON_RANGE, days: 'Sábado', weekdays: [6] }
        ];
    }
    if (zone.includes('fisherton') || zone.includes('funes') || zone.includes('roldan')) {
        return suburbSchedule;
    }

    if (shippingZoneId === 'macrocentro') return macrocentroSchedule;
    if (['fisherton', 'funes_baigorria', 'roldan'].includes(shippingZoneId)) return suburbSchedule;
    return fullWeekSchedule;
};

const getLocalWeekday = (dateValue: string) => {
    const [year, month, day] = dateValue.split('-').map(Number);
    if (!year || !month || !day) return -1;
    return new Date(year, month - 1, day).getDay();
};

export const getAvailableShippingTimeRanges = (
    dateValue: string,
    mapZoneName = '',
    shippingZoneId = ''
) => {
    if (!dateValue) return [];
    const weekday = getLocalWeekday(dateValue);
    return getShippingSchedule(mapZoneName, shippingZoneId)
        .filter(range => range.weekdays.includes(weekday))
        .map(range => range.time);
};

export const formatShippingSchedule = (mapZoneName = '', shippingZoneId = '') =>
    getShippingSchedule(mapZoneName, shippingZoneId)
        .map(range => `${range.days}: ${range.time}`)
        .join(' · ');
